import axios from 'axios';

let url = 'http://113.125.39.38:8080/renren-fast/index/';

let service = axios.create({
    baseURL: url,
    headers: {
        'Content-Type': 'application/json',
    },

    timeout: 30000, // 请求超时时间
});

//拦截request
service.interceptors.request.use(
    config => {
        if (config.method == 'post' && config.data) {
            // config.data=qs.stringify(config.data)
            //   console.log(config)
        }
        config.params = { ...config.params, timestamp: Date.now() };
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    response => {
        // console.log(response);
        let data = response;
        return data.data;
    },
    error => {
        // console.log('失败');
        // self.location = "#upgrade";
        // window.location.reload();

        return Promise.reject(error);
    }
);

export default {
    service,
};
